import {convertCoordinates} from '@/api/util-coordinates';

class TouristRouteApiResponseModel {
  // #region Props

  // #endregion
  constructor(
    {
      name,
      province,
      region,
      cx,
      cy,
      // visible,
      itinerary,
      gastronomy,
      accommodation,
      kms,
      id,
    },
    locale = 'es-ES',
  ) {
    const kmsNumberFormat = new Intl.NumberFormat(locale, {
      style: 'decimal',
      maximumFractionDigits: 0,
    });
    return {
      name,
      province,
      region,
      itinerary,
      gastronomy,
      accommodation,
      kms: kmsNumberFormat.format(kms),
      id,
      coordinates: convertCoordinates(cx, cy),
      visible: false, // TODO: Quitar cuando esté en la api
    };
  }
}

export default TouristRouteApiResponseModel;
